// extracted by mini-css-extract-plugin
module.exports = {"prodwrapper":"productwrapper-component_prodwrapper__1mrQX"};